if (window.top !== window.self) {
  window.top.location = window.self.location;
}
import "@babel/polyfill";
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue';
import { BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import router from "./router/index.js";
import Sidebar from "./layouts/Sidebar.vue";
import NoSidebar from "./layouts/NoSidebar.vue";
import DashboardSidebar from "./layouts/DashboardSidebar.vue";
import partnerSidebar from "./layouts/partnerSideBar.vue";
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from '@/locale/i18n';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBell, faUserSecret, faTachometerAlt, faUserCircle, faFileAlt, faArrowUp, faChartLine } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import Dropdown from 'bp-vuejs-dropdown';
import IdleVue from 'idle-vue'
import { VueperSlides, VueperSlide } from 'vueperslides'
import $ from 'jquery';
Vue.component('font-awesome-icon', FontAwesomeIcon)
library.add(faBell, faUserSecret, faTachometerAlt, faUserCircle, faFileAlt, faChartLine, faArrowUp)
Vue.component("sidebar-layout", Sidebar);
Vue.component("no-sidebar-layout", NoSidebar);
Vue.component("dashboard-layout", DashboardSidebar)
Vue.component("partner-sidebar-layout", partnerSidebar)
import VueGoogleCharts from 'vue-google-charts'
 
Vue.use(VueGoogleCharts)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Vuetify)
Vue.use(Dropdown)
Vue.use(VueAwesomeSwiper)
Vue.use(AOS)
Vue.use(VueperSlides, VueperSlide)
const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 1200000
})
window.EventBus = new Vue();
window.$ = $;
Vue.config.silent = true

Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  EventBus.$emit('stopAudio')
  next()
});
router.afterEach((to, from) => {
  EventBus.$emit('updatepageguides')
});
new Vue({
  created() {
    AOS.init({
      duration: 1500,
    })
  },
  data() {
    return {
      messageStr: 'Hello'
    }
  },

  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
